import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Input,
  Typography,
  Button,
  Modal,
  Checkbox,
  Select,
  InputNumber,
  Steps,
  Divider,
  Row,
  message,
  Spin,
  Segmented,
  ConfigProvider,
} from "antd";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { updatePropery, getAllProperties } from "../Actions/propertiesActions";
import "./styles/clients.css";
import { LoadingOutlined } from "@ant-design/icons";
import moment from "moment";
import { getClients } from "../Actions/clientActions";
const PropertyType = [
  { value: 8, label: "Office" },
  { value: 9, label: "Shop" },
  { value: 10, label: "Showroom" },
  { value: 11, label: "Godown" },
  { value: 12, label: "Wear House" },
  { value: 17, label: "Redevelopment" },
];
const PropertyStatus = [
  { value: 0, label: "Available" },
  { value: 1, label: "Sold Out" },
  { value: 2, label: "On hold" },
  { value: 3, label: "Rented" },
];
const ClientType = [
  { value: 0, label: "Buyer" },
  { value: 1, label: "Seller" },
  { value: 2, label: "Rent Owner" },
  { value: 3, label: "Rent Client" },
];
const { Step } = Steps;
const steps = [
  {
    title: "Personal Details",
    // content: 'First-content',
  },
  {
    title: "Property Details",
    // content: 'Second-content',
  },
];

const schema = Yup.object().shape({
  name: Yup.string().required("Required"),
  type_of_client: Yup.string().required("Required"),
  mobile_number: Yup.string().required("Required"),
  area_id: Yup.string().required("Required"),
  cost: Yup.string().required("Required"),
});
const developerSchema = Yup.object().shape({
  area_id: Yup.string().required("Required"),
  cost: Yup.string().required("Required"),
});
const { TextArea } = Input;
const { Text } = Typography;
export const UpdateCommercialProperties = ({
  id,
  setPopoverVisible,
  itemKey,
  currentUser,
  disabled = false,
}) => {
  const dispatch = useDispatch();
  const { properties, isUpdatePropertyLoading } = useSelector(
    (state) => state.properties
  );
  const { clients } = useSelector((state) => state.clients);
  const { areas } = useSelector((state) => state.areas);
  const the_property = properties.filter((property) => property.id === id);

  const {
    handleSubmit,
    errors,
    control,
    reset,
    getValues,
    trigger,
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(
      itemKey === "21" || currentUser?.role === "Employee"
        ? developerSchema
        : schema
    ),
    defaultValues: the_property[0],
    mode: "all",
  });
  const mobileInput = watch("mobile_number") || "";
  const watching = watch(["is_furnished"]);
  const { is_furnished } = watching;
  const [createDialog, setCreateDialog] = useState(false);
  const [vastuValue, setVastuValue] = useState(
    the_property && the_property[0]?.vastu_complient === 0 ? "Yes" : "No"
  );
  const [current, setCurrent] = React.useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (mobileInput && mobileInput.length === 10) {
      const matchedClient = clients.find(
        (client) => client.mobile_number === mobileInput
      );

      if (matchedClient) {
        setValue("name", matchedClient.name || "");
        setValue("type_of_client", matchedClient.client_type || "");
      } else {
        setValue("name", "");
        setValue("type_of_client", "");
      }
    } else {
      setValue("name", "");
      setValue("type_of_client", "");
    }
  }, [mobileInput, clients, setValue]);

  useEffect(() => {
    if (the_property?.length > 0) {
      const constructionYear = the_property[0].construction_year;

      const formattedDate = constructionYear
        ? moment(constructionYear, moment.ISO_8601, true).isValid()
          ? moment(constructionYear).format("YYYY-MM-DD")
          : ""
        : "";

      const formattedData = {
        ...the_property[0],
        construction_year: formattedDate,
      };
      reset(formattedData);
    }
  }, [JSON.stringify(the_property), reset]);

  if (!the_property || !the_property[0]) {
    return null;
  }
  const newDate = the_property[0].created_at
    ? the_property[0].created_at.split("/")
    : {};
  const newDate1 = the_property[0].last_communication_date
    ? the_property[0].last_communication_date.split("/")
    : {};
  const newDate2 = the_property[0].agreement_date
    ? the_property[0].agreement_date.split("/")
    : {};
  const newDate3 = the_property[0].renewal_date
    ? the_property[0].renewal_date.split("/")
    : {};

  the_property[0].created_at =
    newDate.length > 2
      ? `${newDate[2]}-${newDate[1]}-${newDate[0]}`
      : newDate[0];
  the_property[0].last_communication_date =
    newDate1.length > 2
      ? `${newDate1[2]}-${newDate1[1]}-${newDate1[0]}`
      : newDate1[0];
  the_property[0].agreement_date =
    newDate2.length > 2
      ? `${newDate2[2]}-${newDate2[1]}-${newDate2[0]}`
      : newDate2[0];
  the_property[0].renewal_date =
    newDate3.length > 2
      ? `${newDate3[2]}-${newDate3[1]}-${newDate3[0]}`
      : newDate3[0];

  the_property[0].area_id = the_property[0].area.id;
  if (itemKey === "21") {
    the_property[0].client_id = the_property[0].client.id;
  }
  the_property[0].name = the_property[0].client.name || "";
  the_property[0].type_of_client = the_property[0].client.client_type || "";
  the_property[0].mobile_number = the_property[0].client.mobile_number || "";

  const next = () => {
    const {
      name: clientName,
      type_of_client: type_of_client,
      mobile_number: mobileNumber,
      area_id: aid,
      property_type: PT,
      cost: cst,
    } = getValues([
      "name",
      "type_of_client",
      "mobile_number",
      "area_id",
      "property_type",
      "cost",
    ]);

    const skipInitialFields =
      itemKey === "21" || currentUser?.role === "Employee";

    if (
      current === 0 &&
      ((!skipInitialFields &&
        (!clientName ||
          type_of_client === undefined ||
          type_of_client === null ||
          !mobileNumber)) ||
        !aid ||
        !PT)
    ) {
      const fieldsToTrigger = ["area_id", "property_type"];
      if (!skipInitialFields) {
        fieldsToTrigger.unshift("name", "type_of_client", "mobile_number");
      }
      trigger(fieldsToTrigger);
    } else if (current === 1 && !cst) {
      trigger(["cost"]);
    } else {
      setCurrent(current + 1);
    }
  };

  const prev = () => {
    setCurrent(current - 1);
  };
  const handleUpdateProperty = (data, event) => {
    data.is_commercial = true;
    data.id = id;

    if (itemKey !== "19") {
      if (!data.client) {
        data.client = {};
      }
      data.client.name = data.name;
      data.client.type_of_client = data.type_of_client;
      data.client.mobile_number = data.mobile_number;
    }
    data.vastu_complient = vastuValue === "Yes" ? 0 : 1;
    event.preventDefault();
    if (itemKey === "21") {
      dispatch(
        updatePropery(
          data,
          "is_commercial&is_developer=true",
          successUpdateCommercialProperty,
          failureUpdateCommercialProperty
        )
      );
    } else {
      dispatch(
        updatePropery(
          data,
          "is_commercial",
          successUpdateCommercialProperty,
          failureUpdateCommercialProperty
        )
      );
    }
  };
  const successUpdateCommercialProperty = () => {
    setOpen(false);
    // reset();
    dispatch(getClients());
    setTimeout(() => {
      message.success(
        `You have successfully update ${
          itemKey === "21" ? "builder's" : ""
        } commercial property.`
      );
    }, 2000);
  };
  const failureUpdateCommercialProperty = () => {
    setTimeout(() => {
      message.info("Something went wrong.");
    }, 2000);
    setOpen(false);
    reset();
  };
  // const handleUpdateProperty = (data, event) => {
  //   event.preventDefault();
  //   data.id = id;
  //   dispatch(updatePropery(data,"is_commercial", UpdateCallBack));
  // };
  // const UpdateCallBack = (data) => {
  //   setCreateDialog(false);
  //   setCurrent(0);
  //   reset(data);
  //   setOpen(false);
  //   setTimeout(() => {
  //     message.success("Update Commercial property successful.");
  //   }, 2000);
  //   dispatch(getAllProperties());
  // };
  const handleCancel = () => {
    setOpen(false);
    setCurrent(0);
    reset();
  };
  const handleUCP = () => {
    setPopoverVisible(false);
    setOpen(true);
  };
  return (
    <>
      <Button
        type="link"
        style={{ cursor: disabled ? "not-allowed" : "pointer" }}
        onClick={() => handleUCP()}
        disabled={disabled}
      >
        Edit
      </Button>
      {/* <EditTwoTone
          style={{ cursor: "pointer" }}
          onClick={() => setOpen(true)}
        /> */}
      <Modal
        title={`Edit ${
          itemKey === "21" ? "Builder's" : ""
        } Commercial Property details`}
        open={open}
        onCancel={() => handleCancel()}
        footer={null}
        width={800}
        maskClosable={false}
      >
        <Steps
          current={current}
          size="small"
          responsive="true"
          labelPlacement="vertical"
        >
          {steps.map((item) => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>

        <form onSubmit={handleSubmit(handleUpdateProperty)}>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            {itemKey === "21" ? (
              <Col
                style={{ display: current === 0 ? "block" : "none" }}
                xl={8}
                lg={8}
                md={8}
                sm={24}
                xs={24}
              >
                <Row>
                  <Text>Developer</Text>
                </Row>

                <Controller
                  as={
                    <Select
                      showSearch
                      style={{ width: "100%" }}
                      optionLabelProp="label"
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {clients &&
                        clients.length > 0 &&
                        clients.map((val) => {
                          const designation = val.designation
                            ? `(${val.designation})`
                            : "";
                          const displayName = val.company || val.name;

                          return (
                            <Select.Option
                              key={val.id}
                              value={val.id}
                              label={displayName}
                            >
                              <div>
                                <span>{val.company || "N/A"}</span>
                                <br />
                                <span style={{ fontSize: "13px" }}>
                                  {val.name}
                                </span>
                                <span style={{ fontSize: "12px" }}>
                                  {" "}
                                  {designation}
                                </span>
                              </div>
                            </Select.Option>
                          );
                        })}
                    </Select>
                  }
                  control={control}
                  name="client_id"
                />
              </Col>
            ) : (
              <>
                {currentUser.role !== "Employee" && (
                  <>
                    <Col
                      style={{ display: current === 0 ? "block" : "none" }}
                      xl={8}
                      lg={8}
                      md={8}
                      sm={24}
                      xs={24}
                    >
                      <Row>
                        <Text>Client name</Text>
                      </Row>
                      <Controller
                        as={Input}
                        name="name"
                        control={control}
                        placeholder="Enter client name"
                      />
                      {errors.name && (
                        <span className="error_style">
                          Client name is required
                        </span>
                      )}
                    </Col>
                    <Col
                      xl={8}
                      lg={8}
                      md={8}
                      sm={24}
                      xs={24}
                      style={{ display: current === 0 ? "block" : "none" }}
                    >
                      <Row>
                        <Text>Client Type</Text>
                      </Row>
                      <Controller
                        as={Select}
                        control={control}
                        options={ClientType}
                        style={{ width: "100%" }}
                        name="type_of_client"
                      />
                      {errors.type_of_client && (
                        <span className="error_style">
                          Client Type is required
                        </span>
                      )}
                    </Col>
                    <Col
                      xl={8}
                      lg={8}
                      md={8}
                      sm={24}
                      xs={24}
                      style={{ display: current === 0 ? "block" : "none" }}
                    >
                      <Row>
                        <Text>Client Mobile number</Text>
                      </Row>
                      <Controller
                        name="mobile_number"
                        control={control}
                        rules={{ required: true, minLength: 10, maxLength: 10 }}
                        render={({ value, onChange }) => (
                          <Input
                            value={value}
                            onChange={(e) => onChange(e.target.value)}
                            maxLength={10}
                            placeholder="Enter mobile number"
                          />
                        )}
                      />
                      {errors.mobile_number && (
                        <span className="error_style">
                          Mobile number is required
                        </span>
                      )}
                    </Col>
                  </>
                )}
              </>
            )}
            <Col
              style={{ display: current === 0 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Property Type</Text>
              </Row>
              <Controller
                as={Select}
                control={control}
                options={PropertyType}
                name="property_type"
                style={{ width: "100%" }}
              />
              {errors.property_type && (
                <span className="error_style">Property Type is required</span>
              )}
            </Col>
            <Col
              style={{ display: current === 0 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Entry Date</Text>
              </Row>
              <Controller
                as={Input}
                name="created_at"
                control={control}
                placeholder="Entry Date"
                type="date"
                format="DD-MM-YYYY"
                // defaultValue={new Date()}
              />
              {errors.created_at && (
                <span className="error_style">Entry Date is required</span>
              )}
            </Col>
            <Col
              style={{ display: current === 0 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Office/Shop/Godown No.</Text>
              </Row>
              <Controller
                as={Input}
                name="unique_number"
                control={control}
                placeholder="Office/Shop/Godown No."
              />
              {errors.unique_number && (
                <span className="error_style">
                  Office/Shop/Godown No is required
                </span>
              )}
            </Col>
            {itemKey === "21" && (
              <Col
                style={{ display: current === 0 ? "block" : "none" }}
                xl={16}
                lg={16}
                md={16}
                sm={24}
                xs={24}
              >
                <Row>
                  <Text>Address</Text>
                </Row>
                <Controller
                  as={Input}
                  name="address"
                  control={control}
                  placeholder="Address"
                />
                {errors.unique_number && (
                  <span className="error_style">Address is required</span>
                )}
              </Col>
            )}
          </Row>

          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            {itemKey !== "21" && (
              <Col
                style={{ display: current === 0 ? "block" : "none" }}
                xl={16}
                lg={16}
                md={16}
                sm={24}
                xs={24}
              >
                <Row>
                  <Text>Address</Text>
                </Row>
                <Controller
                  as={Input}
                  name="address"
                  control={control}
                  placeholder="Address"
                />
                {errors.unique_number && (
                  <span className="error_style">Address is required</span>
                )}
              </Col>
            )}
            <Col
              style={{ display: current === 0 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Landmark</Text>
              </Row>
              <Controller
                as={Input}
                name="landmark"
                control={control}
                placeholder="Landmark"
              />
              {errors.landmark && (
                <span className="error_style">Landmark is required</span>
              )}
            </Col>
            {itemKey == "21" && (
              <>
                {" "}
                <Col
                  style={{ display: current === 0 ? "block" : "none" }}
                  xl={8}
                  lg={8}
                  md={8}
                  sm={24}
                  xs={24}
                >
                  <Row>
                    <Text>Area</Text>
                  </Row>
                  <Controller
                    as={Select}
                    control={control}
                    showSearch
                    options={
                      areas &&
                      areas.length > 0 &&
                      areas.map((val, index) => {
                        return { label: val.name, value: val.id };
                      })
                    }
                    filterOption={(input, option) =>
                      option.label.toLowerCase().indexOf(input.toLowerCase()) >=
                      0
                    }
                    style={{ width: "100%" }}
                    name="area_id"
                  />
                  {errors.area_id && (
                    <span className="error_style">Area is required</span>
                  )}
                </Col>
                <Col
                  style={{ display: current === 0 ? "block" : "none" }}
                  xl={8}
                  lg={8}
                  md={8}
                  sm={24}
                  xs={24}
                >
                  <Row>
                    <Text>Google Link</Text>
                  </Row>
                  <Controller
                    as={Input}
                    name="google_link"
                    control={control}
                    placeholder="City"
                  />
                  {errors.google_link && (
                    <span className="error_style">City is required</span>
                  )}
                </Col>
              </>
            )}
          </Row>

          <Row gutter={[8, 16]}>
            <Col span={24}></Col>

            {itemKey !== "21" && (
              <>
                <Col
                  style={{ display: current === 0 ? "block" : "none" }}
                  xl={8}
                  lg={8}
                  md={8}
                  sm={24}
                  xs={24}
                >
                  <Row>
                    <Text>Area</Text>
                  </Row>
                  <Controller
                    as={Select}
                    control={control}
                    showSearch
                    options={
                      areas &&
                      areas.length > 0 &&
                      areas.map((val, index) => {
                        return { label: val.name, value: val.id };
                      })
                    }
                    filterOption={(input, option) =>
                      option.label.toLowerCase().indexOf(input.toLowerCase()) >=
                      0
                    }
                    style={{ width: "100%" }}
                    name="area_id"
                  />
                  {errors.area_id && (
                    <span className="error_style">Area is required</span>
                  )}
                </Col>
                <Col
                  style={{ display: current === 0 ? "block" : "none" }}
                  xl={8}
                  lg={8}
                  md={8}
                  sm={24}
                  xs={24}
                >
                  <Row>
                    <Text>Google Link</Text>
                  </Row>
                  <Controller
                    as={Input}
                    name="google_link"
                    control={control}
                    placeholder="City"
                  />
                  {errors.google_link && (
                    <span className="error_style">City is required</span>
                  )}
                </Col>
              </>
            )}
            <Col
              style={{ display: current === 0 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Property Status</Text>
              </Row>
              <Controller
                as={Select}
                control={control}
                options={PropertyStatus}
                name="property_status"
                style={{ width: "100%" }}
              />
              {errors.property_status && (
                <span className="error_style">Property Status is required</span>
              )}
            </Col>
            {itemKey === "21" && (
              <Col
                style={{ display: current === 0 ? "block" : "none" }}
                xl={8}
                lg={8}
                md={8}
                sm={24}
                xs={24}
              >
                <Row>
                  <Text>Last Communication Date</Text>
                </Row>
                <Controller
                  as={Input}
                  name="last_communication_date"
                  control={control}
                  placeholder="Last Communication Date"
                  type="date"
                  format="DD-MM-YYYY"
                  // defaultValue={new Date()}
                />
                {errors.created_at && (
                  <span className="error_style">
                    Last Communication Date is required
                  </span>
                )}
              </Col>
            )}
          </Row>
          {itemKey !== "21" && (
            <Row gutter={[8, 16]}>
              <Col span={24}></Col>

              <Col
                style={{ display: current === 0 ? "block" : "none" }}
                xl={8}
                lg={8}
                md={8}
                sm={24}
                xs={24}
              >
                <Row>
                  <Text>Last Communication Date</Text>
                </Row>
                <Controller
                  as={Input}
                  name="last_communication_date"
                  control={control}
                  placeholder="Last Communication Date"
                  type="date"
                  format="DD-MM-YYYY"
                  // defaultValue={new Date()}
                />
                {errors.created_at && (
                  <span className="error_style">
                    Last Communication Date is required
                  </span>
                )}
              </Col>
            </Row>
          )}
          <Row>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
            >
              <Divider plain>Property Area</Divider>
            </Col>
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row>
                <Text>Super Builtup Area SqFt</Text>
              </Row>
              <Controller
                as={Input}
                name="property_area_attributes[super_builtup_area_sqFt]"
                type="number"
                control={control}
                placeholder="Super Builtup Area SqFt"
              />
            </Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row>
                <Text>Less %</Text>
              </Row>
              <Controller
                as={Input}
                name="property_area_attributes[less_sqFt]"
                type="number"
                control={control}
                placeholder="Less %"
              />
            </Col>
            {/* <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row>
                <Text>Builtup Area SqFt</Text>
              </Row>
              <Controller
                as={Input}
                name="property_area_attributes[builtup_area_sqFt]"
                type="number"
                control={control}
                placeholder="Builtup Area SqFt"
              />
            </Col> */}
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row>
                <Text>Carpet Area SqFt</Text>
              </Row>
              <Controller
                as={Input}
                name="property_area_attributes[carpet_area_sqFt]"
                type="number"
                control={control}
                placeholder="Carpet Area SqFt"
              />
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Floor</Text>
              </Row>
              <Controller
                as={Input}
                name="floor"
                control={control}
                placeholder="Floor"
                type="number"
              />
              {errors.floor && (
                <span className="error_style">Floor is required</span>
              )}
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Total Floor</Text>
              </Row>
              <Controller
                as={Input}
                name="total_floor"
                control={control}
                placeholder="Total Floor"
                type="number"
              />
              {errors.total_floor && (
                <span className="error_style">Total Floor is required</span>
              )}
            </Col>
          </Row>
          <Row>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
            >
              <Divider plain>Cost</Divider>
            </Col>
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Price per Sqft</Text>
              </Row>
              <Controller
                name="cost_one"
                control={control}
                render={(props) => (
                  <InputNumber
                    style={{ width: "100%" }}
                    formatter={(value) =>
                      value
                        ? `₹ ${new Intl.NumberFormat("en-IN").format(value)}`
                        : "₹ "
                    }
                    parser={(value) => value.replace(/₹\s?|(,*)/g, "")}
                    {...props}
                  />
                )}
              />
              {errors.cost_one && (
                <span className="error_style">Price per Sqft is required</span>
              )}
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Extra per Sqft </Text>
              </Row>
              <Controller
                name="cost_two"
                control={control}
                render={(props) => (
                  <InputNumber
                    style={{ width: "100%" }}
                    formatter={(value) =>
                      value
                        ? `₹ ${new Intl.NumberFormat("en-IN").format(value)}`
                        : "₹ "
                    }
                    parser={(value) => value.replace(/₹\s?|(,*)/g, "")}
                    {...props}
                  />
                )}
              />
              {errors.cost_two && (
                <span className="error_style">Extra per Sqft is required</span>
              )}
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Total Cost </Text>
              </Row>
              <Controller
                name="cost"
                control={control}
                render={(props) => (
                  <InputNumber
                    style={{ width: "100%" }}
                    formatter={(value) =>
                      value
                        ? `₹ ${new Intl.NumberFormat("en-IN").format(value)}`
                        : "₹ "
                    }
                    parser={(value) => value.replace(/₹\s?|(,*)/g, "")}
                    {...props}
                  />
                )}
              />
              {errors.cost && (
                <span className="error_style">Total Cost is required</span>
              )}
            </Col>
          </Row>
          <Divider />
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={6}
              lg={6}
              md={6}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Facing</Text>
              </Row>
              <Controller
                as={Input}
                name="facing"
                control={control}
                placeholder="Facing"
              />
              {errors.facing && (
                <span className="error_style">Facing is required</span>
              )}
            </Col>
            {/* <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={6}
              lg={6}
              md={6}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Vastu Complient</Text>
              </Row>
              <Controller
                as={Input}
                name="vastu_complient"
                control={control}
                placeholder="Vastu Complient"
                type="number"
              />
              {errors.vastu_complient && (
                <span className="error_style">Vastu Complient is required</span>
              )}
            </Col> */}
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={6}
              lg={6}
              md={6}
              sm={24}
              xs={24}
            >
              <Typography>Vastu Compliance</Typography>
              <ConfigProvider
                theme={{
                  components: {
                    Segmented: {
                      itemActiveBg: "none",
                      itemColor: "none",
                      itemSelectedBg: "#c0cdf2",
                      itemSelectedColor: "#000",
                      itemHoverBg: "none",
                      itemHoverColor: "none",
                    },
                  },
                }}
              >
                <Segmented
                  options={["Yes", "No"]}
                  value={vastuValue}
                  onChange={setVastuValue}
                  block
                  className="segmentedForm"
                />
              </ConfigProvider>

              {errors.vastu_complient && (
                <span className="error_style">Vastu Complient is required</span>
              )}
            </Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={6}
              lg={6}
              md={6}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Construction Year</Text>
              </Row>
              <Controller
                as={Input}
                name="construction_year"
                control={control}
                placeholder="Construction Year"
                type="date"
              />
            </Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={6}
              lg={6}
              md={6}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Visit Time</Text>
              </Row>
              <Controller
                as={Input}
                name="visit_time"
                control={control}
                placeholder="Visit Time"
                type="time"
              />
              {errors.visit_time && (
                <span className="error_style">Visit Time is required</span>
              )}
            </Col>
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row>
                <Text>Agreement Date</Text>
              </Row>
              <Controller
                as={Input}
                name="agreement_date"
                type="date"
                format="DD-MM-YYYY"
                control={control}
                placeholder="Agreement Date"
              />
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row>
                <Text>Renewal Date</Text>
              </Row>
              <Controller
                as={Input}
                name="renewal_date"
                type="date"
                control={control}
                placeholder="Renewal Date"
                format="DD-MM-YYYY"
              />
            </Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>About Key</Text>
              </Row>
              <Controller
                as={Input}
                name="about_key"
                control={control}
                placeholder="About Key"
              />
              {errors.about_key && (
                <span className="error_style">About Key is required</span>
              )}
            </Col>
          </Row>

          <Row gutter={[0, 16]}>
            <Col span={24}></Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={4}
              lg={4}
              md={4}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>New</Text>
                </Col>
                <Col>
                  <Controller
                    name="is_new"
                    control={control}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={4}
              lg={4}
              md={4}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Resell</Text>
                </Col>
                <Col>
                  <Controller
                    name="is_resell"
                    control={control}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={4}
              lg={4}
              md={4}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Rent</Text>
                </Col>
                <Col>
                  <Controller
                    name="is_rent"
                    control={control}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={4}
              lg={4}
              md={4}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Lease</Text>
                </Col>
                <Col>
                  <Controller
                    name="is_lease"
                    control={control}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className="notes_box"
            >
              <Row>
                <Text>Details</Text>
              </Row>
              <Controller
                as={TextArea}
                name="details"
                control={control}
                rows={4}
                showCount
                maxLength={100}
              />
              {errors.details && (
                <span className="error_style">Details is required</span>
              )}
            </Col>
          </Row>
          <Row>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
            >
              <Divider plain>Property Furniture</Divider>
            </Col>
          </Row>

          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Furnished</Text>
                </Col>
                <Col>
                  <Controller
                    name="is_furnished"
                    control={control}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Electronics</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_furniture_attributes[electronics]"
                    control={control}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Pentry</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_furniture_attributes[pentry]"
                    control={control}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Attachable Washroom</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_furniture_attributes[attachable_washroom]"
                    control={control}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display:
                  current === 1 && is_furnished === true ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Air Condition</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_furniture_attributes[air_condition]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
            >
              <Divider plain>Property Amenity</Divider>
            </Col>
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Water Supply</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_amenity_attributes[water_supply]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Water 24hr</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_amenity_attributes[water_24hr]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Png</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_amenity_attributes[png]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Security</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_amenity_attributes[security]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>cctv</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_amenity_attributes[cctv]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            {/* </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col> */}
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Lift</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_amenity_attributes[lift]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Common Parking</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_amenity_attributes[common_parking]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Paid parking</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_amenity_attributes[paid_parking]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Common Plot</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_amenity_attributes[common_plot]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
            >
              <Divider plain>Property Nearby</Divider>
            </Col>
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Religious Place</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_nearby_attributes[religious_place]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Park Garden</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_nearby_attributes[park_garden]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Educational Institute</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_nearby_attributes[educational_institute]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Hospital/Dispansary</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_nearby_attributes[hospital_dispansary]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Mall/market</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_nearby_attributes[mall_market]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Bus Stop</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_nearby_attributes[bus_stop]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          <Row justify="end" gutter={[8, 16]}>
            <Col span={24}></Col>
            {!isUpdatePropertyLoading && current > 0 && (
              <Button style={{ margin: "0 8px" }} onClick={() => prev()}>
                Previous
              </Button>
            )}
            {current < steps.length - 1 && (
              <Button type="primary" onClick={() => next()}>
                Next
              </Button>
            )}

            {current === steps.length - 1 && (
              <>
                {isUpdatePropertyLoading ? (
                  <Spin
                    indicator={
                      <LoadingOutlined
                        style={{
                          fontSize: 24,
                        }}
                        spin
                      />
                    }
                  />
                ) : (
                  <Button type="primary" htmlType="submit">
                    Update
                  </Button>
                )}
              </>
            )}
          </Row>
        </form>
      </Modal>
    </>
  );
};
